import React, { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  BoxArrowRight,
  ChevronLeft,
  ChevronRight,
  ClipboardCheck,
  Folder2Open,
  KeyFill,
  List,
  PeopleFill,
  Speedometer2,
} from 'react-bootstrap-icons';
import logo from '../../assets/images/login-logo.png';
import '../../assets/styles/storePortal.css';

const StoreLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('storeUser') || 'null');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    () => localStorage.getItem('storeSidebarCollapsed') === 'true'
  );
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const logout = () => {
    localStorage.removeItem('storeToken');
    localStorage.removeItem('storeUser');
    navigate('/store-login', { replace: true });
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed((current) => {
      const nextValue = !current;
      localStorage.setItem('storeSidebarCollapsed', String(nextValue));
      return nextValue;
    });
  };

  const closeMobileSidebar = () => setIsMobileSidebarOpen(false);
  const isSalaryStatementPreview = /^\/store\/salary-statements\/[^/]+$/.test(location.pathname);
  const outletName = user?.outletName || 'Store Outlet';

  const menuItems = [
    { label: 'Dashboard', path: '/store/dashboard', icon: Speedometer2 },
    { label: 'Active Employees', path: '/store/employees', icon: PeopleFill },
    { label: 'Uniform Forms', path: '/store/uniform-forms', icon: ClipboardCheck },
    { label: 'Documents / Files', path: '/store/files', icon: Folder2Open },
    { label: 'Change Password', path: '/store/change-password', icon: KeyFill },
  ];

  return (
    <div className={`store-portal-layout ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      {isMobileSidebarOpen && (
        <button
          type="button"
          className="store-mobile-backdrop"
          aria-label="Close store menu"
          onClick={closeMobileSidebar}
        />
      )}

      <aside
        className={`store-sidebar ${isSidebarCollapsed ? 'collapsed' : ''} ${
          isMobileSidebarOpen ? 'mobile-open' : ''
        }`}
      >
        <div className="store-sidebar-brand">
          <img src={logo} alt="Logo" className="store-sidebar-logo" />
          <div className="store-sidebar-brand-text">
            <h5>Store Portal</h5>
            <span>{user?.outletName || 'Outlet Dashboard'}</span>
          </div>
        </div>

        <button
          type="button"
          className="store-sidebar-toggle"
          onClick={toggleSidebar}
          aria-label={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          title={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isSidebarCollapsed ? <ChevronRight /> : <ChevronLeft />}
        </button>

        <nav className="store-sidebar-nav" aria-label="Store portal navigation">
          {menuItems.map(({ label, path, icon: Icon }) => {
            const isActive = location.pathname === path || location.pathname.startsWith(`${path}/`);
            return (
              <Link
                key={path}
                className={`store-nav-link ${isActive ? 'active' : ''}`}
                to={path}
                title={label}
                onClick={closeMobileSidebar}
              >
                <Icon className="store-nav-icon" />
                <span className="store-sidebar-label">{label}</span>
              </Link>
            );
          })}
        </nav>
      </aside>

      <main className="store-main">
        <header className="store-topbar">
          <div className="store-topbar-left">
            <button
              type="button"
              className="store-mobile-menu-btn"
              onClick={() => setIsMobileSidebarOpen(true)}
              aria-label="Open store menu"
            >
              <List />
            </button>
            <div>
              <span className="store-topbar-kicker">Welcome back</span>
              <h1>{outletName}</h1>
              <p>Store Portal</p>
            </div>
          </div>

          <button type="button" className="store-logout-btn" onClick={logout}>
            <BoxArrowRight />
            <span>Logout</span>
          </button>
        </header>

        <div className={`store-content ${isSalaryStatementPreview ? 'store-content-salary-preview' : ''}`}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default StoreLayout;
